<template>
    <ModalTitle
        :model-value="props.modelValue"
        @update:model-value="fnModalValueChanged"
        :backdrop="false"
        container-class="w-[690px] max-w-[95vw]"
    >
        <template #header>
            <h1 class="" style="line-height: 40px;"> 
                {{ $t('waves.howTitle') }}
            </h1>
        </template>
        <!-- ↑标题 -->
        <!-- ↓主体 -->
        <section class="modal__container" >
            <section class="body">
                <div class="body__inner">
                    <div class="body__steps">
                        <div class="step">
                            <div class="step__text">
                                <p class="step__index">
                                    {{ $t('waves.s1Title01') }}
                                </p>
                                <h4 class="step__title">
                                    {{ $t('waves.s1Title02') }}
                                </h4>
                                <p class="step__description">
                                    {{ $t('waves.s1Desc') }}
                                </p>
                            </div>
                            <img class="body__image--right body__image"
                                alt="step image"
                                src="../img/how-to-play-1.png"
                            >
                        </div>
                        <div class="step">
                            <div class="step__text" style="order: 2;">
                                <p class="step__index">
                                    {{ $t('waves.s2Title01') }}
                                </p>
                                <h4 class="step__title">
                                    {{ $t('waves.s2Title02') }}
                                </h4>
                                <p class="step__description">
                                    {{ $t('waves.s2Desc') }}
                                </p>
                            </div>
                            <img class="body__image--left body__image"
                                src="../img/how-to-play-2.png"
                                alt="step image"
                            >
                        </div>
                        <div class="step">
                            <div class="step__text">
                                <p class="step__index">
                                    {{ $t('waves.s3Title01') }}
                                </p>
                                <h4 class="step__title">
                                    {{ $t('waves.s3Title02') }}
                                </h4>
                                <p class="step__description">
                                    {{ $t('waves.s3Desc') }}
                                </p>
                            </div>
                            <img class="body__image--right body__image"
                                src="../img/how-to-play-3.png"
                                alt="step image"
                            >
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <!-- ◆分界 -->
        <template #footer>
            <button type="button"
                class="close-btn" 
                @click="fnModalValueChanged(false)"
            >
                <span class="button-flat__inner" >
                    <span class="button-flat__text">
                        {{ $t('waves.close') }}
                    </span>
                </span >
            </button>
        </template>
    </ModalTitle>
</template>


<script lang="ts" setup>

const props = defineComponent({
    modelValue: {
        type: Boolean, // 管制可性性
        default: false,
    },
});

const emits = defineEmits(['update:modelValue']);

function fnModalValueChanged(newVal){
    emits('update:modelValue', !!newVal);
}

</script>

<style scoped lang="scss">
.close-btn{
    padding: 10px 32px;
    border-radius: 10px;
    font-size: 14px;
    background-color: var(--color_grey-60);
    border-color: transparent;
    color: var(--color_grey-20);
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    -moz-appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    display: inline-block;
    position: relative;
    text-align: center;
    text-decoration: none;
    transition: color .1s ease-in-out,background-color .1s ease-in-out,border-color .1s ease-in-out;
    white-space: nowrap;
    &:hover{
        background-color: var(--color_grey-80);
        color: var(--color_grey-20);
    }
    &:active{
        background-color: var(--color_grey-100);
        color: var(--color_grey-20);
    }
}

// =====================================================

.modal__container.has-height .body__inner,
.secondary-tab .tab-inner .body__inner {
    overflow-y: auto;
    scrollbar-color: var(--color_grey-60) rgba(13,19,28,.8);
    scrollbar-width: thin
}

.modal__container.has-height .body__inner::-webkit-scrollbar-track,
.secondary-tab .tab-inner .body__inner::-webkit-scrollbar-track {
    background-color: #0d131ccc;
    border-radius: 2px
}

.modal__container.has-height .body__inner::-webkit-scrollbar,
.secondary-tab .tab-inner .body__inner::-webkit-scrollbar {
    background-color: #0d131ccc;
    border-radius: 2px;
    height: 4px;
    width: 4px
}

.modal__container.has-height .body__inner::-webkit-scrollbar-thumb,
.secondary-tab .tab-inner .body__inner::-webkit-scrollbar-thumb {
    background-color: var(--color_grey-60);
    border-radius: 2px
}

.modal {
    background-color: var(--color_background-90);
    border-radius: 14px;
    overflow: hidden;
    position: relative;
    transition: height .3s
}

.modal__btn-close {
    align-items: center;
    background-color: transparent;
    border: none;
    color: var(--color_grey-20);
    display: flex;
    font-size: 38px;
    font-weight: 500;
    height: 38px;
    justify-content: center;
    line-height: 38px;
    outline: none;
    padding: 0;
    position: absolute;
    right: 15px;
    top: 15px;
    transition: color .1s ease-in-out;
    width: 38px;
    z-index: 10
}

.modal__btn-close--white {
    color: var(--color_white);
    right: 6px;
    top: 6px
}

.modal__btn-close:hover {
    color: var(--color_white)
}

.modal__container {
    color: var(--color_white);
    padding: 0;
    position: relative;
    z-index: 2;
    // ↓ 后补
    max-height: calc(100vh - 64px - 73px - 100px);
    overflow-y: auto;
}

.default-tab,
.secondary-tab {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative
}

.modal__container .tab-inner {
    display: flex;
    flex-direction: column;
    height: 100%
}

.modal__container .header {
    padding: 20px 24px;
    position: relative;
    transition: background-color .3s,border-bottom-color .3s
}

.modal__container .header__subtitle {
    color: var(--color_grey-20);
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 22px;
    margin-top: 2px
}

.modal__container .header__title {
    align-items: center;
    display: flex
}

.modal__container .header h1,
.modal__container .header h2 {
    margin: 0 .5em 0 0
}

.modal__container .header h1 {
    font-size: 24px
}

.modal__container .header h2 {
    font-size: 18px;
    margin-left: .5em;
    margin-right: .5em
}

.modal__container .header+.body .body__inner:before {
    display: none
}

.modal__container .body {
    flex: 1 1;
    min-height: 200px;
    position: relative
}

.modal__container .body:after,
.modal__container .body:before {
    content: "";
    display: block;
    height: 40px;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    right: 4px;
    transition: opacity .3s;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    z-index: 2
}

.modal__container .body:before {
    background: linear-gradient(0deg,transparent,rgba(17,25,35,.5));
    top: 0
}

.modal__container .body:after {
    background: linear-gradient(180deg,transparent,rgba(17,25,35,.5));
    bottom: 0
}

.modal__container .body__inner {
    padding: 0 24px
}

.modal__container .footer {
    background-color: var(--color_background-80);
    border-top: 1px solid rgba(183,207,255,.05);
    padding: 16px 24px
}

.default-tab {
    z-index: 1
}

.default-tab .modal__btn-close {
    position: absolute
}

.default-tab .header {
    border-bottom: 1px solid transparent
}

.default-tab .header:before {
    background: linear-gradient(180deg,#003370,#08264a 40%,#111923);
    bottom: 0;
    content: "";
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: bottom .3s;
    z-index: -1
}

.default-tab .body__inner:before {
    background: linear-gradient(180deg,#003370,#08264a 40%,#111923);
    content: "";
    display: block;
    height: 70px;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: bottom .3s;
    z-index: -1
}

.secondary-tab {
    background-color: var(--color_background-90);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1
}

.secondary-tab .header {
    align-items: center;
    border-bottom: 1px solid transparent;
    display: flex
}

.secondary-tab .tab-inner {
    height: calc(100% - 73px)
}

.secondary-tab .tab-inner .body__inner {
    bottom: 0;
    left: 0;
    overflow-y: scroll;
    position: absolute;
    right: 0;
    top: 0
}

.modal__container.top-shadow .default-tab .header {
    border-bottom-color: #b7cfff0d
}

.modal__container.top-shadow .default-tab .header:before {
    bottom: -40%
}

.modal__container.top-shadow .secondary-tab .header {
    background-color: var(--color_background-80);
    border-bottom-color: #b7cfff0d
}

.modal__container.top-shadow .body:before {
    opacity: 1
}

.modal__container.bottom-shadow .body:after {
    opacity: 1
}

.modal__container.has-height .body__inner {
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    position: absolute;
    right: 0;
    top: 0
}

.slide-fade-to-right-enter-active,
.slide-fade-to-right-leave-active {
    transition: transform .2s ease-in-out
}

.slide-fade-to-right-enter,
.slide-fade-to-right-leave-to {
    transform: translate(100%)
}

// ========================================

.body {
    scrollbar-color: var(--color_grey-60) rgba(13,19,28,.8);
    scrollbar-width: thin;

}

.body::-webkit-scrollbar,
.body::-webkit-scrollbar-track {
    background-color: #0d131ccc;
    border-radius: 2px
}

.body::-webkit-scrollbar {
    height: 4px;
    width: 4px
}

.body::-webkit-scrollbar-thumb {
    background-color: var(--color_grey-60);
    border-radius: 2px
}

h4,p {
    margin: 0
}

.header {
    height: 72px
}

@media (max-width: 576px) {
    .header {
        height:auto
    }
    .modal__container{ // 后补 
        margin-inline: -10px;
    }
}

.body {
    // padding: 0 16px;
    padding: 0;
    overflow-x: hidden;
    overflow-y: hidden;
}

.body__inner {
    padding: 0!important
}

.body__image {
    max-height: 256px;
    max-width: 337px
}

.body__image--right {
    margin-left: 24px;
    margin-right: -24px
}

@media (max-width: 360px) {
    .body__image--right {
        margin-right:0
    }
}

.body__image--left {
    margin-left: -24px;
    margin-right: 24px
}

@media (max-width: 360px) {
    .body__image--left {
        margin-left:0
    }
}


@media (max-width: 576px) {
    .body__image {
        max-width:100%
    }
}

@media (max-width: 360px) {
    .body__image {
        height:190px;
        max-width: 360px
    }
}

.body__top-description {
    color: #93acd3;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin-bottom: 0
}

.body__top-img {
    margin-top: 24px
}

.body__title {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -.02em;
    line-height: 32px;
    margin: 35px auto 0;
    text-align: center
}

.body__steps {
    flex-direction: column;
    max-width: 100%
}

.body .step,.body__steps {
    display: flex;
    justify-content: space-between
}

.body .step {
    align-items: center;
    border-bottom: 1px solid rgba(85,101,126,.2);
    padding: 16px 8px;
    // ↓ 后补
    padding-inline: 0;
    overflow: hidden;
}

@media (max-width: 576px) {
    .body .step {
        flex-direction:column;
        height: auto;
        padding: 16px 0
    }
}

.body .step__text {
    max-width: calc(50% - 25px)
}

@media (max-width: 576px) {
    .body .step__text {
        max-width:100%
    }
}

.body .step__index {
    color: #93acd3;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .06em;
    line-height: 18px;
    margin-bottom: 5px;
    text-transform: uppercase
}

@media (max-width: 576px) {
    .body .step__index {
        text-align:center
    }
}



.body .step__title {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 20px;
    margin-bottom: 0;
    margin-top: 0
}

@media (max-width: 576px) {
    .body .step__title {
        text-align:center
    }
}


.body .step__description {
    color: #93acd3;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 0;
    margin-top: 6px
}

@media (max-width: 576px) {
    .body .step__description {
        font-size:12px;
        font-weight: 500;
        line-height: 18px;
        margin-bottom: 12px;
        text-align: center
    }
}


</style>

